
import { FormEvent, useState } from "react";
import { IFuelRequest, IMaintenanceRequest } from "../../../utils/types";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { DateTime } from "luxon";

const MaintenanceRequestCompleteForm = (props: any) => {
    
    const [open,setOpen] = useState<boolean>(props.state)
    const [request,setRequest] = useState<IMaintenanceRequest>(props.data)

    const handleClose = ()=>{
        setOpen(false);
        props.onClose()
    }
 const handleFormSubmit = (event: FormEvent) => {
    event.preventDefault();
    const e = event as unknown as FormEvent<HTMLFormElement>
    const formData = new FormData(e.currentTarget);
    const formJson = Object.fromEntries((formData as any).entries());
    props.onSubmit(formJson)
    handleClose();
  }
   
    return (<>
       <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleFormSubmit
        }}
      >
        <DialogTitle>Complete Fuel Request</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Fill this form to complete the service request, providing the actual cost
          </DialogContentText>
          <label>Serviced Date</label>
          <input
            autoFocus
            required
            id="date"
            name="date"
            type="date"
            className="form-control"
            defaultValue={DateTime.fromMillis(Date.now()).toLocaleString(DateTime.DATE_MED)}
          />
          <label>Actual Maintenance Cost (TSH)</label>
          <input
            autoFocus
            required
            id="cost"
            name="cost"
            type="number"
            defaultValue={request.cost}
            className="form-control"
          />
          
           <label>Actual Mileage (Km)</label>
           <input
            autoFocus
            required
            id="mileage"
            name="mileage"
            type="number"
            className="form-control"
            defaultValue={request.mileage}
          />
           <label>Comment</label>
          <input
            placeholder="Any comment"
            id="comment"
            name="comment"
            type="text"
            defaultValue={props.comment}
            className="form-control"
          />
        </DialogContent>
        <DialogActions>
          <button onClick={handleClose} className="text-accent">Cancel</button>
          <button type="submit" className="bg-green-700">Save</button>
        </DialogActions>
      </Dialog>
    </>);
}
export default MaintenanceRequestCompleteForm;